module.exports = __webpack_public_path__ + "img/icon-power-btn.a1e5bf28.svg";